import React, { useEffect, useState } from "react";

import { formType, stages } from "./Index";
import { Icons, Images } from "../../assets";
import { Button } from "../../components";
interface GetTheReportProps {
  setCurrentStage: React.Dispatch<React.SetStateAction<stages>>;
  onChange: (field: string, value: Record<string, string | boolean>) => void;
  submit: () => void;
  form: formType | null;
}

export default function GetTheReport({
  setCurrentStage,
  onChange,
  submit,
  form,
}: GetTheReportProps) {
  //go back to the previous stage
  const handleBackClicked = () => {
    setCurrentStage(stages.commuteFrequency);
  };
  const { CheckBox, checkedItems } = useCheckBox();

  useEffect(() => {
    onChange("checkbox", checkedItems);
  }, [checkedItems]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Form Section */}
      <div className="md:max-w-[70%] justify-center place-self-center">
        <div className="mb-8">
          <p className="font-bold text-2xl mb-3">Get the report</p>
          <p>
            Your footprint is ready! Discover your daily, weekly, and yearly
            carbon emissions.
          </p>
        </div>
        <div className="flex flex-col gap-6">
          {inputFields.map(({ title }) => {
            const name = title?.split(" ").join("_").toLocaleLowerCase();
            return (
              <TextInput
                title={title}
                value={
                  (form?.user && form.user[name as keyof typeof form.user]) ||
                  ""
                }
                onChange={(t) =>
                  onChange("user", {
                    [title.split(" ").join("_").toLocaleLowerCase()]: t,
                  })
                }
              />
            );
          })}
          <div className="flex flex-col gap-2">
            <CheckBox
              name="newsletter"
              text="I would like to receive the newsletter and regular updates from The Carbon Games"
            />
            <CheckBox
              name="save_user_info"
              text="Save my info for future access to pre-fill forms and save time on sign-up ."
            />
          </div>
        </div>
        <div className="flex gap-3 mt-6 place-items-center justify-center md:justify-start">
          <Button inverted title="Back" onClick={handleBackClicked} />
          <Button title="Send me the report!" onClick={submit} />
        </div>
      </div>

      {/* Image Section */}
      <div className="hidden md:flex justify-center items-center">
        <img
          src={Images.placeholder_Image}
          alt="placeholder image"
          className="w-full max-w-[500px] h-auto"
        />
      </div>
    </div>
  );
}
interface TextInputProps {
  title: string;
  required?: boolean;
  value?: string;
  onChange?: (t: string) => void;
}
const TextInput = ({
  title,
  required = true,
  onChange,
  value,
}: TextInputProps) => {
  return (
    <div className=" flex flex-col gap-2">
      <p>{`${title}${required && " *"}`}</p>
      <div className="flex w-full border border-black rounded-lg px-3 py-2 gap-2">
        <input
          type="text"
          className="w-full outline-none text-text-grey"
          onChange={(e) => onChange && onChange(e.target.value)}
          value={value}
        />
      </div>
    </div>
  );
};

// const CheckBox = ({ text }: { text?: string }) => {
//   const [checked, setChecked] = useState(false);
//   const handleClick = () => {
//     setChecked((checked) => !checked);
//   };

//   return (
//     <div className="flex items-center gap-2">
//       <div
//         className={`flex justify-center place-items-center w-6 h-6 border border-black rounded flex-shrink-0 cursor-pointer hover:bg-black ${
//           checked ? "bg-black" : "bg-white"
//         }`}
//         onClick={handleClick}
//       >
//         {/* Checkmark will appear on hover or when checked */}
//         {checked && (
//           <span className="text-xl text-white ">
//             &#10003; {/* Unicode for checkmark */}
//           </span>
//         )}
//       </div>
//       <p>{text}</p>
//     </div>
//   );
// };

const inputFields = [
  {
    title: "Name",
  },
  {
    title: "Company",
  },
  {
    title: "Company Email",
  },
];

const useCheckBox = () => {
  const [checkedItems, setCheckedItems] = useState<Record<string, boolean>>({});

  const CheckBox = ({ text, name }: { text: string; name?: string }) => {
    const key = name ?? text;
    const isChecked = checkedItems[key] || false;

    const toggleCheck = () => {
      setCheckedItems((prev) => ({
        ...prev,
        [key]: !isChecked,
      }));
    };

    return (
      <div className="flex items-center gap-2">
        <div
          className={`flex justify-center place-items-center w-6 h-6 border border-black rounded flex-shrink-0 cursor-pointer hover:bg-black ${
            isChecked ? "bg-black" : "bg-white"
          }`}
          onClick={toggleCheck}
        >
          {/* Checkmark will appear on hover or when checked */}
          {isChecked && (
            <span className="text-xl text-white ">
              &#10003; {/* Unicode for checkmark */}
            </span>
          )}
        </div>
        <p>{text}</p>
      </div>
    );
  };

  return { checkedItems, CheckBox };
};
